import { AuthenticationEffect } from './authentication.effect';
// import { GlobalNotificationEffect } from './global-notification.effect';
import { AppNotificationEffect } from './app-notification.efffect';
import { AppChatEffect } from './app-chat.efffect';

export const effects: any[] = [
    AuthenticationEffect, AppNotificationEffect,AppChatEffect
     
];
